module.exports = "/_next/static/images/slide15-c1eccaf856b2aa06b5cf1b76be67e323.webp";